// extracted by mini-css-extract-plugin
module.exports = {"root":"path-btn_root__XHrYn"};